// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"21":"1afe01c7","414":"467a504d","668":"85770e35","752":"cf8e5c0a","823":"96d012d6"}[chunkId] + ".css";
};